import AxiosContent from '@/services/api/content/axios_content'

export default {
  // ==================== MARKUP SESSION ====================
  
  /**
   * POST /markup/session
   * Create a new markup session
   */
  createMarkupSession(data) {
    return AxiosContent.post('/markup/session', data)
  },

  /**
   * PUT /markup/session/{markupSessionId}
   * Update markup session name
   */
  updateMarkupSession(markupSessionId, data) {
    return AxiosContent.put(`/markup/session/${markupSessionId}`, data)
  },

  /**
   * GET /markup/session/{markupSessionId}
   * Get markup session details
   */
  getMarkupSession(markupSessionId) {
    return AxiosContent.get(`/markup/session/${markupSessionId}`)
  },

  /**
   * GET /markup/session/format-instance/{formatInstanceId}
   * Get all sessions for a format instance
   */
  getMarkupSessionsByFormatInstance(formatInstanceId, params = {}) {
    return AxiosContent.get(`/markup/session/format-instance/${formatInstanceId}`, { params })
  },

  /**
   * GET /markup/session/{markupSessionId}/stats
   * Get session statistics
   */
  getMarkupSessionStats(markupSessionId) {
    return AxiosContent.get(`/markup/session/${markupSessionId}/stats`)
  },

  // ==================== MARKUP SESSION NODE ====================

  /**
   * POST /markup/session/{sessionId}/node
   * Create a markup session node (link file to session)
   */
  createMarkupSessionNode(sessionId, data) {
    return AxiosContent.post(`/markup/session/${sessionId}/node`, data)
  },

  /**
   * PUT /markup/session-node/{sessionNodeId}
   * Update session node status
   */
  updateMarkupSessionNode(sessionNodeId, data) {
    return AxiosContent.put(`/markup/session-node/${sessionNodeId}`, data)
  },

  /**
   * GET /markup/session-node/{sessionNodeId}
   * Get session node details
   */
  getMarkupSessionNode(sessionNodeId) {
    return AxiosContent.get(`/markup/session-node/${sessionNodeId}`)
  },

  /**
   * GET /markup/session-node/session/{sessionId}
   * Get all nodes in a session
   */
  getMarkupSessionNodesBySession(sessionId, params = {}) {
    return AxiosContent.get(`/markup/session-node/session/${sessionId}`, { params })
  },

  // ==================== MARKUP ====================

  /**
   * POST /markup
   * Create a new markup
   */
  createMarkup(data) {
    return AxiosContent.post('/markup', data)
  },

  /**
   * PUT /markup/{markupId}
   * Update markup
   */
  updateMarkup(markupId, data) {
    return AxiosContent.put(`/markup/${markupId}`, data)
  },

  /**
   * GET /markup/{markupId}
   * Get markup details
   */
  getMarkup(markupId) {
    return AxiosContent.get(`/markup/${markupId}`)
  },

  /**
   * GET /markup/by-session-node/{sessionNodeId}
   * Get all markups for a session node
   */
  getMarkupsBySessionNode(sessionNodeId, params = {}) {
    return AxiosContent.get(`/markup/by-session-node/${sessionNodeId}`, { params })
  },

  /**
   * GET /markup/by-session/{markupSessionId}
   * Get all markups for a session
   */
  getMarkupsBySession(markupSessionId, params = {}) {
    return AxiosContent.get(`/markup/by-session/${markupSessionId}`, { params })
  },

  // ==================== MARKUP CHAT ====================

  /**
   * POST /markup/chat
   * Create a chat message on a markup
   */
  createMarkupChat(data) {
    return AxiosContent.post('/markup/chat', data)
  },

  /**
   * PUT /markup/chat/{markupChatId}
   * Update chat message (soft delete)
   */
  updateMarkupChat(markupChatId, data) {
    return AxiosContent.put(`/markup/chat/${markupChatId}`, data)
  },

  /**
   * GET /markup/chat/markup/{markupId}
   * Get all chat messages for a markup
   */
  getMarkupChatByMarkup(markupId, params = {}) {
    return AxiosContent.get(`/markup/chat/markup/${markupId}`, { params })
  },

  /**
   * GET /markup/chat/session/{markupSessionId}
   * Get all chat messages for a session
   */
  getMarkupChatBySession(markupSessionId, params = {}) {
    return AxiosContent.get(`/markup/chat/session/${markupSessionId}`, { params })
  }
}
